import { APP_BASE_HREF, Location } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticsService } from '@common/analytics/services/analytics.service';
import { AnalyticsClickService } from '@common/analytics/services/click.service';
import { WINDOW } from '@common/services/window.service';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';

import { AppBase } from '@common/app/app.component.base';
import { CommunityService } from '@common/services/community.service';
import { ContentService } from '@common/services/content.service';
import { GoogleAnalyticsService } from '@common/services/google-analytics.service';
import { KenalyticsService } from '@common/services/kenalytics.service';
import { SeoService } from '@common/services/seo.service';
import { ThemeService } from '@common/services/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent extends AppBase {
    public cmsService: ContentService;

    protected get useTitleFromIndexPage(): boolean {
        return !!this.titleService.getTitle();
    }
    protected get useGenericCommunityServiceErrorHandling(): boolean {
        return false;
    }

    constructor(
        router: Router,
        location: Location,
        analytics: GoogleAnalyticsService,
        protected titleService: Title,
        communityService: CommunityService,
        route: ActivatedRoute,
        contentService: ContentService,
        seoService: SeoService,
        kenalyticsService: KenalyticsService,
        config: NgbDropdownConfig,
        themeService: ThemeService,
        analyticsService: AnalyticsService,
        @Inject(WINDOW) window: Window,
        @Inject(APP_BASE_HREF) baseHref: string,
        clickService: AnalyticsClickService,
    ) {
        super(
            router,
            location,
            analytics,
            titleService,
            communityService,
            route,
            contentService,
            seoService,
            kenalyticsService,
            analyticsService,
            window,
            baseHref,
            clickService,
        );
        this.cmsService = contentService;
        seoService.appendCommunityToTitle = false;
        config.autoClose = 'outside';

        communityService.community$.subscribe((community) => {
            if (community) {
                themeService.loadStyle(`${community.code}.css`);
            }
        });
    }
}
